import {
  TICKET_TYPE_VALUE_TICKET,
  TICKET_TYPE_ADDITIONAL_ZONE,
} from './constants';

export const getTicketPrice = (ticketType, zones) => {
  if (ticketType === TICKET_TYPE_VALUE_TICKET) {
    switch (zones) {
      case 'ABCD':
        return 6.4;
      case 'BCD':
        return 5.4;
      case 'ABC':
        return 4.6;
      case 'CD':
        return 4.2;
      case 'AB':
      case 'BC':
      case 'D':
      default:
        return 2.8;
    }
  }
  if (ticketType === TICKET_TYPE_ADDITIONAL_ZONE) {
    switch (zones) {
      case 'A':
      case 'B':
      case 'C':
        return 2.5;
      case 'AB':
      case 'BC':
      case 'D':
        return 2.8;
      case 'CD':
        return 4.2;
      case 'ABC':
        return 4.6;
      case 'AD':
        return 5.3;
      default:
        return 0;
    }
  }

  return 0;
};

export const formatPrice = (price) => `${parseFloat(price).toFixed(2).toString().replace('.', ',')} €`; // eslint-disable-line
